module.exports = __webpack_public_path__ + "static/media/step-4.03970ecf.svg";